import moment from 'moment';
import React from 'react';
import {
  Button, Col, Modal, Row,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { PROCESS_OPERATION_TYPE_OPTIONS } from 'types/Process';

export type ProcessListItem = {
  id?: string,
  operationType?: string,
  /** Presente cuando `operationType` es REPARTO_CAPITAL. */
  repartoCapitalSubtype?: string,
  globalStatus?: string,
  step2Status?: string,
  step3Status?: string,
  step4Status?: string,
  step5Status?: string,
  notificationResult?: string,
  logsJson?: string | null,
  createdAt?: string,
  updatedAt?: string,
  [key: string]: unknown,
};

type ProcessDetailModalProps = {
  show: boolean,
  onClose: () => void,
  process: ProcessListItem | null,
};

function parseLogsDisplay( logsJson: string | null | undefined ): string {
  if ( logsJson == null || String( logsJson ).trim() === '' ) {
    return '';
  }
  const s = String( logsJson ).trim();
  try {
    const parsed = JSON.parse( s );
    if ( Array.isArray( parsed ) ) {
      return parsed.map( ( line ) => String( line ) ).join( '\n' );
    }
    if ( typeof parsed === 'string' ) return parsed;
    return JSON.stringify( parsed, null, 2 );
  } catch {
    return s;
  }
}

function ProcessDetailModal( { show, onClose, process }: ProcessDetailModalProps ) {
  const { t } = useTranslation();
  const operationLabel = process?.operationType
    ? PROCESS_OPERATION_TYPE_OPTIONS.find( ( o ) => o.value === process.operationType )?.labelKey
    : null;
  const logsText = parseLogsDisplay( process?.logsJson ?? null );

  return (
    <Modal
      show={show}
      centered
      size="lg"
      onHide={onClose}
    >
      <Modal.Header className="pb-0" closeButton />
      <Modal.Body className="pt-0">
        <Row>
          <Col md={11} className="m-auto">
            <h3 className="text-center mb-4">
              {t( 'admin.processes.detailTitle' )}
            </h3>
            <div>
              <h4 className="bg-light p-2 rounded">
                {t( 'admin.processes.logs' )}
              </h4>
              <div className="mt-3 px-3">
                {logsText ? (
                  <pre
                    className="bg-light p-3 rounded mb-0"
                    style={{
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-word',
                      maxHeight: '60vh',
                      overflow: 'auto',
                    }}
                  >
                    {logsText}
                  </pre>
                ) : (
                  <p className="text-muted mb-0">
                    {t( 'admin.processes.noLogs' )}
                  </p>
                )}
              </div>
            </div>
            {operationLabel && (
              <p className="text-muted small mt-3 text-center">
                {t( 'admin.processes.operationType' )}
                {': '}
                {t( operationLabel )}
                {process?.createdAt && ` · ${moment.utc( process?.createdAt ).local().format( 'DD/MM/YYYY HH:mm' )}`}
              </p>
            )}

            <Button
              variant="primary"
              type="button"
              className="btn--full-width mt-4"
              onClick={onClose}
            >
              {t( 'close' )}
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default ProcessDetailModal;
